import {b64_hmac_sha1,b64_sha1} from './sha1'
import { isEnableCdn } from './utils/loadResources';

//以下两个全局变量，所有团队需保持一致。
var W = window; //存在iframe的场景需要使用window.top优先
try{
    //window.top与iframe同域场景则使用顶级window，这样能确保lock_time统一。
    if(window.top.location.origin == window.location.origin){
        W = window.top;
    }
}catch(e){
    //window.top与iframe是跨域场景则使用iframe自己的window。
    console.warn("xscf页面跨域降级兼容")
}
var D = W.document;

const SPECIALDOMAINS = ['com', 'cn', 'asia', 'net', 'info', 'biz', 'pro', 'mobi', 'top', 'org', 'xyz', 'work', 'vip', 'email', 'club', 'site', 'live', 'wang', 'online', 'tech', 'cc', 'fans', 'group', 'host', 'cloud', 'shop', 'team', 'beer', 'ren', 'city', 'co', 'art', 'website', 'icu', 'center', 'tv', 'tw']

// 生成随机hash值
function randomWord (len) {
    let str = '';
    let arr = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
    for (let i=0; i<len; i++) {
        let pos = Math.round(Math.random()*(arr.length - 1))
        str += arr[pos]
    }
    return str;
}
export const CookieHelper = {
    write: function write(name, value, config) {
        var {expires, path, domain, secure, samesite} = config ||{};
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (typeof expires == 'number') {
            cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (typeof path == 'string') {
            cookie.push('path=' + path);
        }

        if (typeof domain == 'string') {
            cookie.push('domain=' + domain);
        }

        if (secure === true) {
            cookie.push('secure');
        }

        if (typeof samesite == 'string') {
            cookie.push('samesite=' + samesite);
        }

        return D.cookie = cookie.join('; ');
    },

    read: function read(name) {
        var match = D.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
    },

    remove: function remove(name) {
        return this.write(name, '', Date.now() - 86400000);
    }
}

W.__XSCF_LAST_TIME__ = W.__XSCF_LAST_TIME__ || new Date().getTime();     //最后一次操作时间
const XSCF_LOCK_TIME = 60*1000;                    //锁定的时间间隔，单位：毫秒（此时间段内的并发操作公用同一个值）

// 生产新的xscfToken值
function genXscfValue(prefix){
    let hashVal = prefix+"_"+randomWord(25);
    let nowTime = new Date();
    let lastVal = getFormatTimeStr(nowTime);
    hashVal = hashVal+"!"+lastVal;
    return hashVal;
}
function getFormatTimeStr(now){
    let hh = now.getHours();//时钟
    if(hh<10)hh="0"+hh;//例如"1"补为"01"
    let mm = now.getMinutes(); //分钟
    if(mm<10)mm="0"+mm;//例如"1"补为"01"
    let ss = now.getSeconds(); //秒钟
    if(ss<10)ss="0"+ss;//例如"1"补为"01"
    return ""+hh+mm+ss;
}
// 校验是否为有效的cookie值
function validXscfValue(oldValue){
    if(!oldValue)return false; // 值不存在则无效
    if(!(oldValue.indexOf("_")>0 && oldValue.indexOf('!')>0))return false;//非tns规范值则无效
    let lastTime = oldValue.split('!')[1];
    if(lastTime.length !== 6)return false;// 时钟+分钟+秒钟长度
    return true;
}
// 校验是否为ip地址，例如：127.0.0.1
function isValidIp (str) {
    return /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(str)
}
// 获取种植cookie的二级域名
export function secondDomain(domain){
    if(!isValidIp(domain)){ //非ip
        if (!isEnableCdn()) {
            return domain;
        }
        if (domain.split('.').length <= 2) {
            return domain.split('.').slice(-2).join('.')
        } else {
            let last2 = domain.split('.').slice(-2);
            if (SPECIALDOMAINS.includes(last2[0]) && SPECIALDOMAINS.includes(last2[1])) { // 倒数第二，一个都包含
                return domain.split('.').slice(-3).join('.')
            } else {
                return domain.split('.').slice(-2).join('.')   
            }
        }
    }
}
// 直接种植cookie值并返回新值
function doWriteXscfToken(prefix){
    let nowTime = new Date().getTime();
    let newValue = genXscfValue(prefix);
    let domain = secondDomain(D.domain);
    let config = {path:'/',expires:nowTime+2*60*60*1000};//cookie值有效期两小时
    if(W.location.protocol == 'https:'){
        //samesite为None的情况 ,secure必须得是 true , secure必须得是true请求就必须得是https请求
        config.secure = true;
        config.samesite = 'None'; //None无论是否跨站都会发送此Cookie
    }
    if(domain)config.domain = domain;
    CookieHelper.write('XSRF-TOKEN',newValue,config);
    return newValue;
}

// https://docs.diwork.com/l/f38418E6F749  2.5章，基于"/me"接口获取yht密钥验签
var YHT_KEY_READY = {ajaxing:false,key:undefined};
function fetchYhtAccessShaKey(){
    if(YHT_KEY_READY.ajaxing)return; //防止频繁调用重复请求
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.timeout = 120000; //单位ms
    xmlhttp.open('get', '/me', true);
    xmlhttp.onreadystatechange = function () {
        if(xmlhttp.readyState === XMLHttpRequest.DONE && xmlhttp.status === 200){
            try{
                let result = JSON.parse(xmlhttp.responseText);
                if(result&&result.data&&result.data.shayat){
                    YHT_KEY_READY.key = result.data.shayat;
                    // console.log("XXX---获得me")
                }
            }catch (e) {}
        }
        YHT_KEY_READY.ajaxing = false;
        //console.log("XXX---等待me-state:"+xmlhttp.status)
    };
    let fail = function(){
        YHT_KEY_READY.ajaxing = false;
        YHT_KEY_READY.key = undefined;
    };
    xmlhttp.onabort = fail;
    xmlhttp.onerror = fail;
    xmlhttp.ontimeout = fail;
    YHT_KEY_READY.ajaxing=true;
    // console.log("XXX---发送me")
    xmlhttp.send();
}

// 是否为绝对url地址 begins with "<scheme>://" or "//" (protocol-relative URL)
export function isAbsoluteURL(url) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
}

// 获取相对路的url，即排除（https，http）和host
export function getRelativeURL(url){
    let refUrl = url;
    if(isAbsoluteURL(url)){
        try{
            let urlObj = new URL(url);
            let {pathname,search} = urlObj;
            refUrl = pathname+search;
        }catch (e) {}
    }
    return refUrl;
}

export function writeXscfToken (prefix) {
    if(!prefix){
        console.error("writeXscfToken缺少参数：prefix");
        return;
    }
    //存在跨iframe情况和其它非法cookie写入的情况，所以需要先检查cookie是否已被种植过以及是否合法。
    let lastValue = CookieHelper.read('XSRF-TOKEN');
    // console.log('AAA---write--lastValue',lastValue,W.location.origin,D);
    let isValid = validXscfValue(lastValue);//校验其它iframe种植的cookie是否规范
    if(isValid){ // 如果存在历史值并且是规范有效的值
        //确保连续write/read的时间间隔大于锁定时间，即在锁定时间内的连续write/read将延长锁定，不做新值写入
        if( (new Date().getTime() - W.__XSCF_LAST_TIME__) > XSCF_LOCK_TIME){
            lastValue = doWriteXscfToken(prefix);
            // console.log('AAA---write--newValue1',lastValue,W.location.origin,D);
        }
    }else{
        // 无论是否有历史值，只要不是规范有效的值，则直接重新写入
        lastValue = doWriteXscfToken(prefix);
        // console.log('AAA---write--newValue2',lastValue,W.location.origin,D);
    }
    if(!lastValue){ //最终确保一定有种植cookie
        lastValue = doWriteXscfToken(prefix);
        // console.log('AAA---write--newValue3',lastValue,W.location.origin,D);
    }
    W.__XSCF_LAST_TIME__ = new Date().getTime();//续命时间
    return lastValue;
}
export function readXscfToken (){
    W.__XSCF_LAST_TIME__ = new Date().getTime(); //续命时间
    let oldValue = CookieHelper.read('XSRF-TOKEN');
    // console.log('AAA---read--oldValue',oldValue,W.location.origin,D);
    let isValid = validXscfValue(oldValue);
    if(!isValid){ // 如果存在历史，并且历史值无效，则进行修正，即写入新值。
        oldValue = doWriteXscfToken("FIX");
        // console.log('AAA---read--fixValue',oldValue,W.location.origin,D);
    }
    return oldValue || "READ_XSCF_UNDEFINED";
}


function getCurrentDiwork(currentWindow) {
    let diworkCtx = {}
    if (typeof currentWindow.diworkContext == 'function'){ //非iframe的场景
        diworkCtx = currentWindow.diworkContext() || {};
    }else if(currentWindow.jDiwork && typeof currentWindow.jDiwork.diworkContext == 'function'){
        diworkCtx = currentWindow.jDiwork.diworkContext() || {};
    }
    return diworkCtx;
}

function getWorkbenchWindow (window) {
    try {
        if (window.parent.location.origin == window.location.origin) { // 同源
            if (window.parent.name === '_WORKBENCH_') {
                return window.parent
            } else {
                return window
            }
        } 
    } catch (e) {
        return window;
    }
    return window;
}

function getAll (window) {
    let key = getCurrentDiwork(window);
    if (!Object.keys(key).length) key = getCurrentDiwork(getWorkbenchWindow(window))
    if (!Object.keys(key).length) {
        if (window.opener) {
            try {
                key = getAll(window.opener)
            } catch(e) {
            
            }
        }
    }
    if(!key){
        console.error('无法获取工作台yhtAccessToken,检测是否存在跨域或是否引入jdiwork.js');
    }
    return key;
}

/**
 * 生成基于uri的token信息
 * @param uri   不带 http(s)和host 的 url+searchParms
 * @param yhtAccessToken    yht验签
 * @param yhtIsSha          yht验签是否已经sha1，设置true则内部不再sha1加密
 * @return {{
 *     'X-REQUEST-TIME':string,
 *     'X-XSRF-TOKEN2':string
 * }}
 */
export function generateUriToken(uri,yhtAccessToken,yhtIsSha) {
    if(!uri){
        console.error("generateUriToken缺少参数：uri");
        return {};
    }
    let diworkCtx = {};
    diworkCtx = getAll(window);

    // if (typeof W.diworkContext == 'function'){ //非iframe的场景
    //     diworkCtx = W.diworkContext() || {};
    // }else if(W.jDiwork && typeof W.jDiwork.diworkContext == 'function' && window.top == window){ //嵌套iframe的场景
    //     diworkCtx = W.jDiwork.diworkContext() || {};
    // }else if (W.opener){ //打开新页签的场景
    //     try{
    //         if(W.opener.jDiwork && typeof W.opener.jDiwork.diworkContext == 'function'){
    //             diworkCtx = W.opener.jDiwork.diworkContext() || {};
    //         } else if(typeof W.opener.diworkContext == 'function') {
    //             diworkCtx = W.opener.diworkContext() || {};
    //         }
    //     }catch (e) {
    //         //本场景一般在本地调试时出现，比如先访问bip-daily后，再访问本地调试local.yyuap.com，而local的window.opener指向bip-daily导致跨域
    //         diworkCtx = {};
    //         console.error('存在跨域访问，无法获取工作台yhtAccessToken',e);
    //     }
    // }
    //如果工作台yms变量[diwork.enableRequestSign]未开启则不追加token2头信息
    if(!diworkCtx.enableRequestSign)return {};
    let relUrl = getRelativeURL(uri);//获取相对路的url，兼容排除（https，http）和host
    let yhtToken = yhtAccessToken;
    if(!yhtToken){//如果外部没有传入，则自动通过diworkContext获取
        let contextExt = diworkCtx.ext || {};
        yhtToken = contextExt.yht_access_token;
        // if(!yhtToken){//diwork都取不到则从/me接口获取
        //     if(YHT_KEY_READY.key){
        //         // console.log("XXX---me-key已存在："+uri);
        //         yhtToken = YHT_KEY_READY.key;
        //         yhtIsSha = true; //接口返回的无需再sha1
        //     }else{
        //         // console.log("XXX---me-key不存在："+uri);
        //         // if(YHT_KEY_READY.ajaxing){
        //         //     logxxx.push("XXX---等待me期间发生的请求："+uri);
        //         //     console.log("XXX---等待me期间发生的请求："+uri);
        //         // }
        //         fetchYhtAccessShaKey(); //异步调用"/me"接口查一次，查询结果未拿到之前header返回{}
        //     }
        // }
    }
    if(!yhtToken)return {};//如果yht_access_token没有则不处理
    let time = new Date().toUTCString();
    let yhtKey = yhtIsSha ? yhtToken : b64_sha1(yhtToken); //加签名
    let headers = {};
    headers['X-REQUEST-TIME'] = time;
    headers['X-XSRF-TOKEN2'] = b64_hmac_sha1(yhtKey, relUrl+time); // 加签名
    return headers;
}
